import React from "react";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";

import * as Middleware from "@middlewares/index";

const HowToUseWithAuth: React.FC = () => {
  SwiperCore.use([Navigation, Pagination]);

  const netwDays = useSelector((state) => state.Networking?.Days.data);

  return (
    <div className="modal-wrap how-to-use">
      <button
        className="modal__close"
        onClick={() => {
          Middleware.Ui.Modal.close();
        }}
      />
      <div className="modal modal--content modal--use-with-auth">
        <div className="modal__header">
          <div className="modal__title">Как пользоваться?</div>
        </div>
        <div className="how-to-use__slider-wrapper">
          <Swiper
            slidesPerView={1}
            spaceBetween={32}
            loop={false}
            pagination={{
              el: ".swiper-pagination",
              clickable: true,
              type: "bullets",
            }}
            navigation={{
              prevEl: ".how-to-use__slider-prev",
              nextEl: ".how-to-use__slider-next",
            }}
          >
            <SwiperSlide>
              <div className="how-to-use__slide">
                <div className="how-to-use__body">
                  <div className="how-to-use__slide-title">
                    Находите участника
                  </div>
                  <div className="how-to-use__slide-desc">
                    Выберите, кого из участников Вы ищете - Компанию или
                    Представителя. Воспользуйтесь поисковой строкой или
                    используйте фильтры для поиска в левой части страницы
                  </div>
                </div>
                <picture className="how-to-use__slide-img">
                  <source
                    srcSet={require("@public/images/netw-find-member-mobile.jpg")}
                    media="(max-width: 767px)"
                  />
                  <source
                    srcSet={require("@public/images/netw-find-member-tablet.jpg")}
                    media="(max-width: 1279px)"
                  />
                  <source
                    srcSet={require("@public/images/netw-find-member-desktop.jpg")}
                  />
                  <img
                    src={require("@public/images/netw-find-member-mobile.jpg")}
                    alt="Находите участника"
                  />
                </picture>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="how-to-use__slide">
                <div className="how-to-use__body">
                  <div className="how-to-use__slide-title">
                    Выбирайте компанию
                  </div>
                  <div className="how-to-use__slide-desc">
                    Выберите интересующую Вас компанию и кликните на нее, чтобы
                    прочитать больше о ее деятельности.
                  </div>
                </div>
                <picture className="how-to-use__slide-img">
                  <source
                    srcSet={require("@public/images/netw-choose-company-mobile.jpg")}
                    media="(max-width: 767px)"
                  />
                  <source
                    srcSet={require("@public/images/netw-choose-company-tablet.jpg")}
                    media="(max-width: 1279px)"
                  />
                  <source
                    srcSet={require("@public/images/netw-choose-company-desktop.jpg")}
                  />
                  <img
                    src={require("@public/images/netw-choose-company-mobile.jpg")}
                    alt="Выбирайте компанию"
                  />
                </picture>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="how-to-use__slide">
                <div className="how-to-use__body">
                  <div className="how-to-use__slide-title">Начните общение</div>
                  {netwDays.length ? (
                    <div className="how-to-use__slide-desc">
                      Выберите представителя компании, с которым хотите
                      установить контакт. Назначьте видео встречу с
                      представителем или просто обменяйтесь визитками
                    </div>
                  ) : (
                    <div className="how-to-use__slide-desc">
                      Выберите представителя компании, с которым хотите
                      установить контакт. Обменяйтесь контактами —
                      онлайн-визитками.
                    </div>
                  )}
                </div>
                <picture className="how-to-use__slide-img">
                  <source
                    srcSet={require("@public/images/netw-start-conversation-mobile.jpg")}
                    media="(max-width: 767px)"
                  />
                  <source
                    srcSet={require("@public/images/netw-start-conversation-tablet.jpg")}
                    media="(max-width: 1279px)"
                  />
                  <source
                    srcSet={require("@public/images/netw-start-conversation-desktop.jpg")}
                  />
                  <img
                    src={require("@public/images/netw-start-conversation-mobile.jpg")}
                    alt="Начните общение"
                  />
                </picture>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className="swiper-pagination how-to-use__slider-pagination" />
      <div className="how-to-use__slider-nav how-to-use__slider-prev" />
      <div className="how-to-use__slider-nav how-to-use__slider-next" />
    </div>
  );
};

export default HowToUseWithAuth;
